import React, { useEffect } from "react"
import { useTranslation } from "next-i18next"
import { InternalLinkIcon } from "@kohler-dsm-library/kohler-icons"
import Image from "@/components/Shared/Image"
import CloseIcon from "@/public/icons/modal-close.svg"
import Styles from "@/components/ShareListModal/index.module.scss"
import { shareListModalDataLayerEvents } from "@/components/ShareListModal/analytics"

const ShareListModal = props => {
  const { t } = useTranslation("common")

  const {
    listName = "",
    showShareListModal = false,
    onClose = () => {},
    URLToShare = "",
    fromPage = "",
  } = props || {}
  const [copied, setCopied] = React.useState(false)

  const handleCloseBtnClick = () => {
    onClose()
    shareListModalDataLayerEvents({
      name: listName,
      actionType: "modal close",
      pageType: fromPage,
      eventStatus: "success",
      eventType: "informative",
      sharedURL: URLToShare,
    })
  }

  const handleCopyLink = async () => {
    try {
      if (!URLToShare) return

      if (navigator?.clipboard?.writeText) {
        await navigator?.clipboard?.writeText(URLToShare)
      } else {
        const textarea = document.createElement("textarea")
        textarea.value = URLToShare
        textarea.setAttribute("readonly", "")
        textarea.style.position = "absolute"
        textarea.style.left = "-9999px"
        document.body.appendChild(textarea)
        textarea.select()
        textarea.setSelectionRange(0, textarea.value.length)
        document.execCommand("copy")
        document.body.removeChild(textarea)
      }

      setCopied(true)
      setTimeout(() => setCopied(false), 3000)
    } catch (err) {
      // fallback attempt if clipboard API failed
      try {
        const textarea = document?.createElement("textarea")
        textarea.value = URLToShare
        textarea.setAttribute("readonly", "")
        textarea.style.position = "absolute"
        textarea.style.left = "-9999px"
        document?.body?.appendChild(textarea)
        textarea.select()
        document?.execCommand("copy")
        document?.body?.removeChild(textarea)
        setCopied(true)
        setTimeout(() => setCopied(false), 3000)
      } catch (e) {
        // swallow errors silently
      }
    }
    shareListModalDataLayerEvents({
      name: listName,
      actionType: "copy link",
      pageType: fromPage,
      eventStatus: "success",
      eventType: "informative",
      sharedURL: URLToShare,
    })
  }
  const handleContinueShopping = () => {
    onClose()
    shareListModalDataLayerEvents({
      name: listName,
      actionType: "continue shopping",
      pageType: fromPage,
      eventStatus: "success",
      eventType: "informative",
      sharedURL: URLToShare,
    })
  }
  useEffect(() => {
    if (typeof document === "undefined") return
    if (!showShareListModal) return

    const previousOverflow = document?.body?.style?.overflow
    document.body.style.overflow = "hidden"

    return () => {
      document.body.style.overflow = previousOverflow || ""
    }
  }, [showShareListModal])

  return showShareListModal ? (
    <div className={Styles.ShareListModalWrapper}>
      <div className="Share-list-modal">
        <div className="modal-body">
          <div className="back-close-btn">
            <div className="close-btn" onClick={handleCloseBtnClick}>
              <Image
                src={CloseIcon?.src}
                role="presentation"
                alt="close"
                width="16"
                height="17"
              />
            </div>
          </div>
          <div className="modal-content">
            <div className="list-header">{t("kf.share.list.title")}</div>
            <div className="list-dec">{t("kf.share.list.title.dec")}</div>
            <div
              className="cta-with-icon"
              onClick={() => {
                handleCopyLink()
              }}
            >
              <InternalLinkIcon />
              <div className="label-cls">
                {copied
                  ? t("kf.share.list.copied")
                  : t("kf.share.list.copy'link")}
              </div>
            </div>
          </div>
        </div>

        <div className="action-btn">
          <button className="action-btn-item" onClick={handleContinueShopping}>
            <span className="action-btn-item-txt">
              {t("kf.share.list.continueShopping")}
            </span>
          </button>
        </div>
      </div>
    </div>
  ) : null
}
export default ShareListModal
